<ol>
  <ng-template
    ngFor
    let-breadcrumb
    [ngForOf]="breadcrumbs"
    let-last="last">
    <li *ngIf="!last">
      <a
        *ngIf="breadcrumb.breadcrumbRoute.url; else noLink"
        [routerLink]="breadcrumb.breadcrumbRoute.url"
        [queryParams]="breadcrumb.breadcrumbRoute.queryParams">
        {{breadcrumb.title}}
      </a>
      <em class="icon-chevron-right"></em>
      <ng-template #noLink>
        <span>{{breadcrumb.title}}</span>
      </ng-template>
    </li>
    <li *ngIf="last">
      <span class="font-semibold">{{breadcrumb.title}}</span>
    </li>
  </ng-template>
</ol>
